import { render } from "./PerruquesMedicalesFemmes.vue?vue&type=template&id=23c6af3e&scoped=true"
import script from "./PerruquesMedicalesFemmes.vue?vue&type=script&lang=js"
export * from "./PerruquesMedicalesFemmes.vue?vue&type=script&lang=js"

import "./PerruquesMedicalesFemmes.vue?vue&type=style&index=0&id=23c6af3e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c6af3e"]])

export default __exports__